import { useEffect, useState } from 'react';

export const usePageLoad = () => {
    const [isPageLoaded, setIsPageLoaded] = useState(false);

    useEffect(() => {
        const handleLoad = () => {
            setIsPageLoaded(true);
        };

        if (document.readyState === 'complete') {
            setIsPageLoaded(true); // If the document is already loaded
        } else {
            window.addEventListener('load', handleLoad); // Otherwise, wait for the load event
        }

        return () => {
            window.removeEventListener('load', handleLoad);
        };
    }, []);

    return isPageLoaded;
};
